import script from "./extra-text-field.vue?vue&type=script&setup=true&lang=js"
export * from "./extra-text-field.vue?vue&type=script&setup=true&lang=js"

import "./extra-text-field.vue?vue&type=style&index=0&id=10219abc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10219abc"]])

export default __exports__